import React from "react";
import {
    Box
} from "@mui/material";
import ProjectDetails from "./aboutProduct/ProjectDetails";
import Process from "./aboutProduct/Process";

const NadirJs = () => {
    return (
        <Box sx={{ margin: "0 auto", maxWidth: 900 }}>
            <ProjectDetails />
            <Process />
        </Box>
    );
};

export default NadirJs;
